import { sizes as defaultSizes } from "../../constants";
import { getImageVariantPath } from "../get-image-variant-path";
export var getSrcSet = function getSrcSet(_ref) {
  var src = _ref.src,
    _ref$sizes = _ref.sizes,
    _sizes = _ref$sizes === void 0 ? defaultSizes : _ref$sizes,
    overrideExtension = _ref.overrideExtension;
  return _sizes.reduce(function (prev, size) {
    var path = getImageVariantPath({
      src: src,
      size: size,
      overrideExtension: overrideExtension
    });
    if (!path) {
      return prev;
    }
    return prev.concat("".concat(path, " ").concat(size));
  }, []).join(', ');
};